module.exports = __webpack_public_path__ + "static/img/wap.26c188a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/北京中加学校/wap.svg
// module id = vVyX
// module chunks = 16